import React, { useEffect, useRef, useState } from 'react'
import videoIcon from '../../images/video.png'
import imageIcon from '../../images/camera.png'
import albumIcon from '../../images/drawing-book.png'
import { get_platform_bg_color, Platform, token_url, getMobileOperatingSystem } from "../../script/util";
import axios from 'axios';
import Card from '../../components/Portfolio/Card';
import './Portfolio.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import Navbar from '../../components/Navbar/Navbar';
import Masonry from "react-masonry-css";
import Skeleton from 'react-loading-skeleton';
import SkeletonLoader from '../../components/SkeletonLoader';
import Carousel from "react-gallery-carousel";
import "react-gallery-carousel/dist/index.css";
import { faAngleLeft, faAngleRight, faArrowRight, faXmark, faEye, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { data } from 'jquery';
import { Helmet } from 'react-helmet';
import VideoPlayer from "../../components/VideoPlayer.js";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { portfolio } from '../../context/workConstants';
import Popup from "../../components/Popup/Popup.js";
import CustomStatus from "../../components/CustomStatus/CustomStatus";


const Portfolio = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const [currentDimensions, setCurrentDimensions] = useState(window?.innerWidth)
    const [portfolioData, setPortfolioData] = useState(null);
    const [albumData, setAlbumData] = useState(null);
    const [portfolioLoading, setPortfolioLoading] = useState(false);
    const [albumLoading, setAlbumLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(false);
    const [tab, setTab] = useState('photos')
    const [workId, setWorkId] = useState(null);
    const [workImages, setWorkImages] = useState(null);
    const [pillMargin, setPillMargin] = useState(15)
    const [initialized, setInitialized] = useState(false);
    const [nextCollection, setNextCollection] = useState(null);
    const [prevCollection, setPrevCollection] = useState(null);
    const [videoView, setVideoView] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null);
    const [videoCollection, setVideoCollection] = useState(null);
    const [galleryNextCollectionPopup, setGalleryNextCollectionPopup] = useState(false)
    const [galleryRightArrow, setGalleryRightArrow] = useState(true);
    const [workIdError, setWorkIdError] = useState(false);
    const [workIdErrorMsg, setWorkIdErrorMsg] = useState('');
    const storyNavRefs = useRef({});
    const workImagesCacheRef = useRef(new Map());
    const photos = 'photos'
    const videos = 'videos'
    const albums = 'albums'
    const [showGallery, setShowGallery] = useState(false);
    const [photoIdx, setPhotoIdx] = useState(0);
    const [galleryPhotos, setGalleryPhotos] = useState([]);
    const carouselRef = useRef(null);
    const thumbRef = useRef(null);
    const height = window.innerHeight;
    const params = new URLSearchParams(window.location.search);
    const hasKey = params.has('key');

    const navigate = useNavigate();
    const { slug } = useParams();
    const location = useLocation();
    const lastViewedWorkIdRef = useRef(null);

    const prepareGallery = () => {
        const myGal = workImages?.data?.map((e, idx) => {
            return {
                src: e.view_url,
                alt: `portfolio image ${idx}`,
                photo_id: e.photo_id
            }
        })

        setGalleryPhotos(myGal);
    }

    useEffect(() => {
        prepareGallery();
    }, [workImages])

    const handleOrientationChange = () => {
        setCurrentDimensions(window.innerWidth)
    };
    
    
   useEffect(() => {
        window.addEventListener('resize', handleOrientationChange);

        return () => {
            window.removeEventListener('resize', handleOrientationChange);
        };
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (!showGallery) return;
                if (event.key === "ArrowRight") {
                    carouselRef.current.goRight()
                } else if (event.key === "ArrowLeft") {
                    carouselRef.current.goLeft()
                }
        };
        window.addEventListener('keydown', handleKeyDown);
        const targetEl = document.querySelector('._lfOsC._dZ8C-');
        if (targetEl) targetEl.style.display = 'none';
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [showGallery, photoIdx]);

    useEffect(() => {
        let cancelled = false;
        let timeout;

        const scrollToLastViewedCard = (attempt = 0) => {
            if (cancelled) return;
            const id = lastViewedWorkIdRef.current;
            if (!id) return;

            const el = storyNavRefs.current[id];
            if (el) {
                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                return;
            }

            // After refresh -> back, the grid cards may mount only after data loads,
            // so retry a bit longer until the ref is populated.
            if (attempt < 3) {
                timeout = setTimeout(() => scrollToLastViewedCard(attempt + 1), 500);
            }
        };

        timeout = setTimeout(() => {
            if (tab === photos && workId) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                return;
            }

            if (tab === photos && !workId && lastViewedWorkIdRef.current) {
                scrollToLastViewedCard(0);
                return;
            }

            if (tab === videos) {
                if (videoView) return;
                const id = lastViewedWorkIdRef.current;
                const el = id ? storyNavRefs.current[String(id)] : null;
                if (el) {
                    el.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'nearest'
                    });
                    return;
                }
            }

            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 500);

        return () => {
            cancelled = true;
            clearTimeout(timeout);
        };
    }, [tab, workId, portfolioData, videoView]);
    

const fetchPortfolioData = (isAlbum = false) => {

    const setLoading = isAlbum ? setAlbumLoading : setPortfolioLoading;
    const setData = isAlbum ? setAlbumData : setPortfolioData;

    setLoading(true);

    const params = new URLSearchParams(window.location.search);
    const shared_key = params.get('key');
    const baseUrl = process.env.REACT_APP_STAG_URL;

    let url;

    if (shared_key) {
        if (slug) {
            url = isAlbum
                ? `${baseUrl}/api/share/pf/v2/${slug}/${shared_key}/album`
                : `${baseUrl}/api/share/pf/v2/${slug}/${shared_key}/`;
        } else {
            url = isAlbum
                ? `${baseUrl}/api/share/pf/${shared_key}/album`
                : `${baseUrl}/api/share/pf/${shared_key}/`;
        }
    } else if (slug) {
        url = isAlbum
            ? `${baseUrl}/api/work/portfolio/album/${slug}/`
            : `${baseUrl}/api/work/portfolio/${slug}/`;
    } else {
        url = isAlbum
            ? `${baseUrl}/api/work/portfolio/album/`
            : `${baseUrl}/api/work/portfolio/`;
    }

    return axios
        .get(url)
        .then((response) => {

            if (response?.data?.success) {
                setData(response?.data?.data);
                setWorkIdError(false);
                setWorkIdErrorMsg('');
                
                const redirectSlug = response?.data?.redirect_slug;
                if (redirectSlug && slug !== redirectSlug) {
                    navigate(`/portfolio/${redirectSlug}/`);
                    return response;
                }
            }
            return response;
        })
        .catch((error) => {
            console.error(error);
            const status = error?.response?.status;

            if (status === 404 && slug) {
                setWorkIdError(true);
                setWorkIdErrorMsg("Invalid URL");
            }
        })
        .finally(() => {
            setLoading(false);
        });
};

const getPortfolioWork = () => fetchPortfolioData(false);

const getAlbumData = () => fetchPortfolioData(true);

    useEffect(() => {
        setWorkIdError(false);
        setWorkIdErrorMsg('');
        getPortfolioWork();
        getAlbumData();

        workImagesCacheRef.current = new Map();
        setAlbumData(null);
    }, [slug, location.search]);

    useEffect(() => {
        if (tab === albums && !albumData) {
            getAlbumData();
        }
    }, [tab, slug, location.search]);


    const updateTab = (newTab) => {
        
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set("tab", newTab);
        const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
        window.history.replaceState({}, '', newUrl);
        lastViewedWorkIdRef.current = null;
        setTab(newTab);
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const initialTab = queryParams.get("tab");

        if (initialTab === photos || initialTab === videos || initialTab === albums) {
            setTab(initialTab);
        } else {
            updateTab(photos)
            setTab(photos);
        }

        setInitialized(true);
    }, []);

    useEffect(() => {
        if (!hasKey && !slug) return;

        const noPhotos = !portfolioData?.['photo-collection'] || portfolioData['photo-collection'].length === 0;
        const hasVideos = portfolioData?.video && portfolioData.video.length > 0;
        const hasAlbums = albumData && albumData.length > 0;

        if(!portfolioLoading && !albumLoading){
            const currentTab = new URLSearchParams(window.location.search).get("tab");

            if (noPhotos) {
                if (!hasVideos && hasAlbums) {
                    updateTab(albums);
                } else if (hasVideos && !hasAlbums) {
                    updateTab(videos);
                } else if (hasVideos && hasAlbums) {
                    updateTab(videos);
                }
            } else if (initialized && currentTab === videos && !hasVideos) {
                updateTab(photos);
            }

            if(initialized && noPhotos && !hasVideos && !hasAlbums){
                setWorkIdError(true);
                setWorkIdErrorMsg("Invalid URL")
            }
        }

    }, [portfolioData, albumData, hasKey, portfolioLoading, albumLoading]);


    const handleTabClick = (newTab) => {
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set("tab", newTab);
    
        if (tab === photos && newTab !== photos) {
            queryParams.delete("work_id");
            setWorkId(null);
            setWorkImages(null);
            lastViewedWorkIdRef.current = null;
        }

        if (tab === videos && newTab !== videos) {
            queryParams.delete("work_id");
            queryParams.delete("video_status");
            setVideoView(false);
            setVideoUrl(null);
            setVideoCollection(null);
            lastViewedWorkIdRef.current = null;
        }

        const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
        window.history.pushState({}, '', newUrl);
        setTab(newTab);
    
    };

    const handleNextCollection = () => {
        setGalleryNextCollectionPopup(false);
        setPhotoIdx(0);
        if (nextCollection) {
            handlePhotoCollectionClick(nextCollection.work_id);
        }
    }

    const handlePrevCollection = () => {
        setGalleryNextCollectionPopup(false);
        setPhotoIdx(0);
        if (prevCollection) {
            handlePhotoCollectionClick(prevCollection.work_id);
        }
    }

    useEffect(() => {
        const handlePopState = () => {
            const queryParams = new URLSearchParams(window.location.search);
            const newTab = queryParams.get("tab");
            const newWorkId = queryParams.get("work_id");
            const videoStatus = queryParams.get("video_status");

            if (newTab) {
                setTab(newTab);
            }

            if (newTab === photos && newWorkId) {
                setWorkId(newWorkId);
                lastViewedWorkIdRef.current = newWorkId;
            } else if (newTab === videos) {

                if (videoStatus === "true" && newWorkId) {
                    lastViewedWorkIdRef.current = String(newWorkId);
                    // user navigated directly to a video via back/forward
                    const videoData = portfolioData?.video?.find(v => String(v.work_id) == String(newWorkId));
                    if (videoData) {
                        setVideoCollection(videoData);
                        setVideoUrl(videoData.url);
                        setVideoView(true);
                    }
                } else {
                    // closing video overlay (back to videos tab)
                    setVideoView(false);
                    setVideoUrl(null);
                    setVideoCollection(null);
                    document.body.style.overflow = 'auto';
                }
            } else {
                setWorkId(null);
                setWorkImages(null);
                setVideoView(false);
                setVideoUrl(null);
                setVideoCollection(null);
                document.body.style.overflow = 'auto';
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);


    useEffect(() => {
        document.body.style.overflow = videoView ? 'hidden' : 'auto';
        return () => { document.body.style.overflow = 'auto'; };
    }, [videoView]);


    const getDataToRender = () => {
        if (portfolioLoading || albumLoading) return [];
        
        switch (tab) {
            case videos:
                return portfolioData?.video || [];
            case albums:
                return albumData || [];
            case photos:
            default:
                return portfolioData?.['photo-collection'] || [];
        }
    }

    const handlePhotoCollectionClick = (selectedWorkId) => {
        if (!selectedWorkId) return;

        const collections = portfolioData?.["photo-collection"];
        const currentIndex = collections?.findIndex(item => item.work_id == selectedWorkId);

        if (currentIndex !== -1 && currentIndex < collections?.length - 1) {
            setNextCollection(collections[currentIndex + 1]);
        } else {
            setNextCollection(null);
        }

        if (currentIndex > 0 && currentIndex < collections.length) {
            setPrevCollection(collections[currentIndex - 1]);
        } else {
            setPrevCollection(null);
        }

        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set("tab", photos);
        queryParams.set("work_id", selectedWorkId);
        const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
        window.history.pushState({}, '', newUrl);
    
        setWorkId(selectedWorkId);
        lastViewedWorkIdRef.current = selectedWorkId;
    };

    const handleVideo = (videoData) => {
        lastViewedWorkIdRef.current = videoData?.work_id ? String(videoData.work_id) : null;

        setVideoCollection(videoData);
        setVideoUrl(videoData.view_url);
        setVideoView(true);

        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set('tab', 'videos');
        queryParams.set('work_id', videoData.work_id);
        queryParams.set('video_status', 'true');
        navigate({ search: queryParams.toString() });

        document.body.style.overflow = 'hidden';
    };


    const closeVideo = () => {
        setVideoView(false);
        setVideoUrl(null);
        setVideoCollection(null);

        const queryParams = new URLSearchParams(window.location.search);
        queryParams.delete("work_id");
        queryParams.delete("video_status");
        queryParams.set("tab", "videos");
        navigate({ search: queryParams.toString() });
    };

    const handleAlbum = (data) => {
        if (data?.view_url) {
            window.open(data.view_url, "_blank");
        }
    };


    useEffect(() => {
        if (tab !== photos) return;
        if (!workId) return;
        if (!portfolioData) return;

        const targetKey = String(workId);
        let cancelled = false;
        let timeoutId;
        let attempt = 0;

        const tryScroll = () => {
            if (cancelled) return;

            const el = storyNavRefs.current[targetKey];
            if (el) {
                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center',
                });
                return;
            }

            if (attempt < 3) {
                attempt += 1;
                timeoutId = setTimeout(tryScroll, 500);
            }
        };

        timeoutId = setTimeout(tryScroll, 0);

        return () => {
            cancelled = true;
            clearTimeout(timeoutId);
        };
    }, [tab, workId, portfolioData]);

    const getNextCollection = (id) => {

        if(!portfolioData){
             getPortfolioWork().then((res) => {
                const updatedData = res.data?.data;
                const collections = updatedData["photo-collection"];
                const currentIndex = collections.findIndex(item => item.work_id == id);

                if (currentIndex !== -1 && currentIndex < collections?.length - 1) {
                    setNextCollection(collections[currentIndex + 1]);
                } else {
                    setNextCollection(null);
                }

                if (currentIndex > 0 && currentIndex < collections?.length) {
                    setPrevCollection(collections[currentIndex - 1]);
                } else {
                    setPrevCollection(null);
                }

            })

        }else{

            if (!id) {
                setNextCollection(null);
                setPrevCollection(null);
                return;
            }

            const collections = portfolioData["photo-collection"];
            const currentIndex = collections.findIndex(item => item.work_id == id);

            if (currentIndex !== -1 && currentIndex < collections.length - 1) {
                setNextCollection(collections[currentIndex + 1]);
            } else {
                setNextCollection(null);
            }

            if (currentIndex > 0 && currentIndex < collections.length) {
                setPrevCollection(collections[currentIndex - 1]);
            } else {
                setPrevCollection(null);
            }

        }

    }


    const fetchWorkImages = (id) => {
        if (!id) return;

        const cached = workImagesCacheRef.current.get(String(id));
        if (cached) {
            setWorkImages(cached);
            setContentLoading(false);
            getNextCollection(id);
            return;
        }

        setWorkImages(null);
        setContentLoading(true);

        const params = new URLSearchParams(window.location.search);

        const url = `${process.env.REACT_APP_STAG_URL}/api/work/portfolio/${id}/`

        axios
            .get(url)
            .then((response) => {
                setContentLoading(false);
                if (response?.data?.success) {
                    workImagesCacheRef.current.set(String(id), response.data);
                    setWorkImages(response.data);

                    const scrollStory = () => {
                        const timeout = setTimeout(() => {
                            const el = storyNavRefs.current[id];

                            if (id && el) {

                                el.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'nearest',
                                    inline: 'center'
                                });
                            }
                        }, 300);

                        return () => clearTimeout(timeout);
                    }
                    scrollStory();


                    getNextCollection(id);

                }else{
                    const firstId = portfolioData?.['photo-collection']?.[0]?.work_id;
                    if (firstId) {
                        handlePhotoCollectionClick(firstId);
                    }
                }
            })
            .catch((error) => {
                setContentLoading(false);
                console.error(error);
            });
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get("work_id");
        if (tab === photos && id) {
            setWorkId(id);
            lastViewedWorkIdRef.current = id;
        } else {
            setWorkImages(null);
        }
    }, [tab, portfolioData]);

    useEffect(() => {
        if (tab === photos && workId && portfolioData) {
            fetchWorkImages(workId);
        }
    }, [workId, portfolioData, tab]);
    
    const breakpointColumnsObj = {
        default: 4,
        1300: 4,
        800: 3,
        600: 2,
    };

    const handleIndexChange = (e)=>{

        let num = parseInt(e.curIndexForDisplay, 10);
        
        if(num>=e.curIndex && num == galleryPhotos.length){
            if((tab === photos) && nextCollection && photoIdx==galleryPhotos.length-1){
                setGalleryRightArrow(true);
                setGalleryNextCollectionPopup(true);
            }else{
                setGalleryNextCollectionPopup(false);
            }

            
        }else{
            if((photoIdx==0 && num==1) && (tab === photos) && prevCollection){
                setGalleryRightArrow(false);
                setGalleryNextCollectionPopup(true);
            }else{
                setGalleryNextCollectionPopup(false);
            }
        }

        setPhotoIdx(e.curIndex);

    }

    const splitTitle = (title) => {
        if (title.length > 11) {
            const [firstWord, ...rest] = title.split(" ");
            const restOfString = rest.join(" ");
            return [firstWord, restOfString];
        } else {
            return [title];
        }
    }

    const renderContent = () => {
        const data = getDataToRender();

        if (!initialized || portfolioLoading || albumLoading || data?.length == 0) return null;

        if (!data) {
            return <div style={{display: 'flex', alignItems: 'center', justifyContent:'center', width: '100vw', height: '100vh', transform: 'translateY(-20%)'}} >No data available</div>;
        }

        if (tab === videos) {
            return data?.map((e, index) => (
                <div
                    key={e?.work_id}
                    ref={(el) => {
                        if (e?.work_id) storyNavRefs.current[String(e.work_id)] = el;
                    }}
                >
                    <Card
                        pic={e?.thumb_url}
                        title={e?.title}
                        btn_text="Play"
                        onClick={() => handleVideo(e)}
                    />
                </div>
            ));
        } else if (tab === albums) {
            return data?.map((data, index) => (
                <Card
                    key={data?.work_id}
                    pic={data?.cover_image}
                    title={data?.title}
                    btn_text="View"
                    onClick={() => handleAlbum(data)}
                />
            ));
        } else {
            if (workId && workImages) {
                return (
                    <Masonry
                        breakpointCols={breakpointColumnsObj}
                        className="my-masonry-grid"
                        columnClassName="my-masonry-grid_column"
                        style={{ position: "relative", paddingBottom: "10rem", }}
                    >
                        {workImages?.data?.map((img, i) => (

                        <div key={i} onClick={() => {
                            
                            setPhotoIdx(i);
                            setShowGallery(true);
                        }}>
                            <img
                                key={i}
                                src={img?.thumb_url}
                                alt={`photo-${i}`}
                                style={{
                                    width: '-webkit-fill-available',
                                    padding: '2.5px',
                                    cursor: 'pointer',
                                }}
                            />

                        </div>

                        ))}
                    </Masonry>
                );
            } else {
                return data?.map((data, i) => (
                    <div
                        key={data?.work_id || data?.title || i}
                        ref={(el) => {
                            if (data?.work_id) storyNavRefs.current[data.work_id] = el;
                        }}
                    >
                        <Card
                            pic={data?.cover_image}
                            title={data?.title}
                            btn_text="View"
                            onClick={() => handlePhotoCollectionClick(data?.work_id)}
                        />
                    </div>
                ));
            }
        }
    }

    if (workIdError) {
        return <CustomStatus errorMessage={workIdErrorMsg} redirectBtn={"Portfolio"} redirectURL={"/portfolio"} />;
    }


    return (
        <>
            <Helmet>
                <title>{Platform?.isEG ? "Portfolio | EventGraphia" : "Portfolio | WedGraphia"}</title>

                {/* Open Graph / Facebook Meta Tags */}
                <meta property="og:title" content={Platform?.isEG ? "Portfolio | EventGraphia" : "Portfolio | WedGraphia"} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.eventgraphia.com/portfolio" />
                <meta property="og:image" content="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/favicon-96x96.png" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />

                {/* Twitter Meta Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={Platform?.isEG ? "Portfolio | EventGraphia" : "Portfolio | WedGraphia"} />
                <meta name="twitter:image" content="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/favicon-96x96.png" />


                {/* Old Meta and Favicons */}
                <meta name="theme-color" content="#007b6a" />
                <meta name="msapplication-TileColor" content="#007b6a" />
                <meta name="msapplication-TileImage" content="https://res.cloudinary.com/eventgraphia/image/upload/v1492249972/webapp/favicon/ms-icon-144x144.png" />
                <link rel="canonical" href="https://www.eventgraphia.com/work-details.html" />

                {/* Favicon Links */}
                <link rel="apple-touch-icon" sizes="57x57" href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249970/webapp/favicon/apple-icon-57x57.png" />
                <link rel="apple-touch-icon" sizes="60x60" href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249970/webapp/favicon/apple-icon-60x60.png" />
                <link rel="apple-touch-icon" sizes="72x72" href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/apple-icon-72x72.png" />
                <link rel="apple-touch-icon" sizes="76x76" href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249970/webapp/favicon/apple-icon-76x76.png" />
                <link rel="apple-touch-icon" sizes="114x114" href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249970/webapp/favicon/apple-icon-114x114.png" />
                <link rel="apple-touch-icon" sizes="120x120" href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249970/webapp/favicon/apple-icon-120x120.png" />
                <link rel="apple-touch-icon" sizes="144x144" href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/apple-icon-144x144.png" />
                <link rel="apple-touch-icon" sizes="152x152" href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/apple-icon-152x152.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/apple-icon-180x180.png" />
                <link rel="icon" type="image/png" sizes="192x192" href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249972/webapp/favicon/android-icon-192x192.png" />
                <link rel="icon" type="image/png" sizes="32x32" href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="96x96" href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/favicon-96x96.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="https://res.cloudinary.com/eventgraphia/image/upload/v1492249971/webapp/favicon/favicon-16x16.png" />

                {/* Manifest */}
                <link rel="manifest" href="/webapp/manifest.json" />
            </Helmet>

        <div>
            <Navbar title={portfolio} />

            {!portfolioLoading && !albumLoading && 
            (<div
                style={{
                    backgroundColor: currentDimensions > 1200 && get_platform_bg_color(),
                    padding: currentDimensions > 1200 && "70px 0 10px",
                    display: 'flex',
                }}
                className={`${(currentDimensions > 1200 ? 'topSwitchTabs' : 'bottomSwitchTabs')}`}
            >
                { ((!slug && !hasKey) || (portfolioData?.['photo-collection'] && portfolioData['photo-collection'].length > 0)) && (
                    <p
                        className="tabsPara"
                        onClick={() => handleTabClick(photos)}
                        style={{ borderBottom: tab === photos && (currentDimensions > 1200 ? '3px solid white' : '3px solid black'), color: currentDimensions <= 1200 && "black" }}
                    >
                        <img className={currentDimensions > 1200 ? "invert-image" : ""} src={imageIcon} style={{ paddingRight: currentDimensions > 600 && "5px" }} />
                        <span>Photos</span>
                    </p>
                )}
                { ((!slug && !hasKey) || (portfolioData?.video && portfolioData.video.length > 0)) && (
                    <p
                        className="tabsPara"
                        onClick={() => handleTabClick(videos)}
                        style={{ borderBottom: tab === videos && (currentDimensions > 1200 ? '3px solid white' : '3px solid black'), color: currentDimensions <= 1200 && "black" }}
                    >
                        <img className={currentDimensions > 1200 ? "invert-image" : ""} src={videoIcon} style={{ paddingRight: currentDimensions > 600 && "5px" }} />
                        <span>Videos</span>
                    </p>
                )}
                { ((!slug && !hasKey) || (albumData && albumData.length > 0)) && (
                    <p
                        className="tabsPara"
                        onClick={() => handleTabClick(albums)}
                        style={{ borderBottom: tab === albums && (currentDimensions > 1200 ? '3px solid white' : '3px solid black'), color: currentDimensions <= 1200 && "black" }}
                    >
                        <img className={currentDimensions > 1200 ? "invert-image" : ""} src={albumIcon} style={{ paddingRight: currentDimensions > 600 && "5px" }} />
                        <span>Albums</span>
                    </p>
                )}
            </div>)
            }
            {(portfolioLoading || albumLoading) ? (
                <div style={{paddingTop: currentDimensions > 1200 && "4rem"}}>
                    <SkeletonLoader />
                </div>
            ): (
            <>
                {(tab === photos && workId) ? 
                    <div style={{paddingTop: currentDimensions < 1200 ? "70px" : "180px"}}>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <div id='storyNav' style={{display: getDataToRender()?.length>1 ? "flex" : 'none', overflow: "auto"}}>
                                {getDataToRender()?.map((e, index)=>(
                                    <div 
                                        ref={el => {
                                            storyNavRefs.current[String(e.work_id)] = el;
                                        }}
                                        onClick={()=>{
                                            handlePhotoCollectionClick(e.work_id);
                                        }} 
                                        key={index} 
                                        className={currentDimensions < 1200 ? `storyDiv ${contentLoading && 'inactiveClass'}` : `pillStoryDiv ${contentLoading && 'inactiveClass'}`} 
                                        style={{
                                            background: e.work_id == workId && currentDimensions > 1200 && get_platform_bg_color(), 
                                            color: e.work_id == workId && currentDimensions > 1200 && 'white', 
                                            boxShadow: e.work_id == workId && currentDimensions > 1200 && "0 -2px 10px rgba(0, 0, 0, 0.4)", 
                                            margin: `15px ${pillMargin}px`
                                        }}
                                    >
                                        <img 
                                            className={currentDimensions < 1200 ? `imgStory ${e.work_id == workId && 'openClass'}` : `pillImgStory ${e.work_id == workId && 'openClass'}`} 
                                            style={{border: e.work_id == workId && currentDimensions <1200 && `3px solid ${get_platform_bg_color()}`}} 
                                            src={e?.cover_image}
                                        />
                                        <div style={{display:"flex", flexDirection:"column"}}>
                                            {splitTitle(e.title).map((e, index)=>{
                                                return (
                                                    <span style={{whiteSpace:"nowrap"}} key={index}>{e.length>11 ? e.slice(0,8)+'...' : e}</span>
                                                )
                                            })}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {contentLoading ? (
                            <div style={{
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                width: '100vw', 
                            }}>
                                <div className="skeleton-grid" style={{width: currentDimensions<600?'100%':'98%' }}>
                                    {[...Array(24)].map((_, index) => (
                                        <div key={index} className="skeleton-item">
                                            <Skeleton height={currentDimensions > 1200 ? 350 : 200} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <>
                                {!contentLoading && (
                                    <div style={{
                                        fontSize: currentDimensions>600 ? '18px' : "15px", 
                                        fontWeight: tab=="100", 
                                        fontStyle:"italic", 
                                        display:"flex", 
                                        alignItems:'center',
                                        justifyContent:'center', 
                                        marginBottom: '20px'
                                    }}>
                                        {workImages?.title?.length>50 ? workImages?.title?.slice(0,49)+'...' : workImages?.title}
                                    </div>
                                )}
                                {renderContent()}

                            {nextCollection && !contentLoading && <div className="nextCollectionDiv" style={{paddingBottom: getMobileOperatingSystem()=="iOS" && '35%', marginBottom: '5rem'}}><button className="nextCollection" onClick={handleNextCollection}>{nextCollection.title} <FontAwesomeIcon icon={faArrowRight} style={{color: "#ffffff",}} size="sm"/></button></div>}

                                
                            </>
                        )}
                    </div>
                :
                    <div className='card-grid' style={{ padding: currentDimensions > 1200 ? '180px 200px' : '60px 10px 100px', marginTop: currentDimensions > 1200 ? "0px": "30px" }}>
                        {renderContent()}
                    </div> 
                }
            </>
            )}


            {showGallery && galleryNextCollectionPopup && (nextCollection || prevCollection) &&
                <Popup 
                isOpen={galleryNextCollectionPopup}
                onClose={()=>setGalleryNextCollectionPopup(false)}>
                <div style={{padding:"0 20px"}}>
                    <div style={{padding: "8px 2px", textAlign: "center"}}>Move to</div>
                        <div className='galleryCollectionButton' style={{backgroundColor: get_platform_bg_color(), border: `1px solid ${get_platform_bg_color()}`, cursor:"pointer"}} onClick={()=>{galleryRightArrow ? handleNextCollection() : handlePrevCollection();}}>
                            {!galleryRightArrow && <FontAwesomeIcon icon={faArrowLeft} style={{color: "#ffffff",}} size="sm"/>} {galleryRightArrow ? nextCollection?.title : prevCollection?.title} {galleryRightArrow && <FontAwesomeIcon icon={faArrowRight} style={{color: "#ffffff",}} size="sm"/>}
                        </div>
                    </div>
                </Popup>
            }

            {showGallery && galleryPhotos && photoIdx >= 0 && (
            <div
                ref={thumbRef}
                style={{
                position: "fixed",
                zIndex: 200,
                top: 0,
                left: 0,
                height: height,
                width: "100vw",
                }}
                className="galleryContainer"
            >
                <Carousel
                ref={carouselRef}
                index={photoIdx}
                images={galleryPhotos}
                hasCaptions={false}
                hasThumbnails={false}
                canAutoPlay={false}
                hasLeftButton={false}
                shouldLazyLoad={true}
                hasRightButton={false}
                isLoop={false}
                onIndexChange={handleIndexChange}
                style={{ height: "100%", width: "100%" }}
                />
                <button
                onClick={() => {carouselRef.current?.goLeft()}}
                style={{
                    position: "absolute",
                    left: 0,
                    top: "44%",
                    zIndex: 201,
                    fontSize: 'min(30px, 5vw)',
                    padding: "4vw 4vw 4vw 2vw",
                    display: !prevCollection && photoIdx==0 && 'none'
                }}
                aria-label="Previous"
                >
                <FontAwesomeIcon icon={faAngleLeft} style={{ color: "#fff", opacity: 0.5 }} />
                </button>
                <button
                onClick={() => carouselRef.current?.goRight()}
                style={{
                    position: "absolute",
                    right: 0,
                    top: "44%",
                    zIndex: 201,
                    fontSize: 'min(30px, 5vw)',
                    padding: "4vw 2vw 4vw 4vw",
                    display: !nextCollection && photoIdx==galleryPhotos.length-1 && 'none'
                }}
                aria-label="Next"
                >
                <FontAwesomeIcon icon={faAngleRight} style={{ color: "#fff", opacity: 0.5 }} />
                </button>
                <button
                onClick={() => setShowGallery(false)}
                style={{
                    position: "absolute",
                    top: "1rem",
                    left: "1rem",
                    background: "#000000aa",
                    color: "white",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    fontSize: "1.2rem",
                    zIndex: 202,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
                >
                ✕
                </button>
            </div>
            )}

            {videoView && videoUrl &&(
                <div>
                    <div style={{ position: "fixed", top: "20px", left: "20px", color: "white", zIndex: "201" }} onClick={closeVideo}>
                        <FontAwesomeIcon icon={faXmark} size="xl" style={{ color: "#ffffff", cursor: "pointer" }} />
                    </div>
                    <div style={{ position: "fixed", width: "100%", top: "0", zIndex: "200" }}>
                        <VideoPlayer data={videoCollection} videoUrl={videoUrl} />
                    </div>
                </div>
            )}


        </div>
    </>
    )
}

export default Portfolio